jQuery(function($) {
	$(document).on('show.bs.modal', '#videoModal', function (event) {
		var videoUrl = $(event.relatedTarget).data('videourl');
		/* Replace the question mark with a parameter which allows auto pause on close window */
		var newUrl = videoUrl.replace(/[?]/, '?enablejsapi=1&');
		$(this).find('.modal-content').html(newUrl);
	});
	$(document).on('hide.bs.modal', '#videoModal', function () {
		$(this).find('iframe')[0].contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*'
		);
	});
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/modules/video-modal.js
// module id = 25
// module chunks = 0